'use client';
import React, {useState} from 'react';
import {useI18n} from '@udemy-v2/i18n';

import styles from './solutions-section.module.scss';
import {SolutionsContent} from './solutions-content';
import {SolutionsHeader} from './solutions-header';

type ImageType = 'mobile' | 'desktop';

interface SolutionsSectionProps {
    imageType: ImageType;
}

const getBannerContents = (gettext: (key: string) => string, imageType: ImageType) => [
    {
        heading: gettext("Be the smartest applicant they've seen"),
        description: gettext(
            'Build the skills that employers on Indeed want, so you can be the right fit',
        ),
        image: `/indeed/learning/skills-${imageType}.png`,
        cta: gettext('Get in-demand skills'),
        url: '/featured-topics/',
    },
    {
        heading: gettext('Show them what you know'),
        description: gettext(
            'Prep for certification exams and impress your next boss with badges from AWS, Microsoft, and more.',
        ),
        image: `/indeed/learning/certifications-${imageType}.png`,
        cta: gettext('Prep for certifications'),
        url: '/browse/certification/',
    },
    {
        heading: gettext('Put your best self forward'),
        description: gettext(
            'Master the art of the interview with development courses that can help you win people over and get you hired.',
        ),
        image: `/indeed/learning/interview-${imageType}.png`,
        cta: gettext('Get interview-ready'),
        url: '/courses/personal-development/career-development/',
    },
];

const SolutionsSection: React.FC<SolutionsSectionProps> = ({imageType}) => {
    const {gettext} = useI18n();
    const [selected, setSelected] = useState(0);

    const tagLabels = [
        gettext('Gain in-demand skills'),
        gettext('Earn certifications'),
        gettext('Get interview-ready'),
    ];

    const bannerContents = getBannerContents(gettext, imageType);

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>
                {gettext('Win the job you want')}
                <br />
            </h1>
            <div className={styles.contentWrapper}>
                <SolutionsHeader selected={selected} onSelect={setSelected} tagLabels={tagLabels} />
                {bannerContents.map((content, index) => (
                    <SolutionsContent
                        selected={index === selected}
                        key={index}
                        heading={content.heading}
                        description={content.description}
                        image={content.image}
                        cta={content.cta}
                        url={content.url}
                    />
                ))}
            </div>
        </div>
    );
};

export {SolutionsSection};
export type {ImageType};
